import { render, staticRenderFns } from "./ProjectPageTotals.vue?vue&type=template&id=bd187a9e&scoped=true&"
import script from "./ProjectPageTotals.vue?vue&type=script&lang=js&"
export * from "./ProjectPageTotals.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPageTotals.vue?vue&type=style&index=0&id=bd187a9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd187a9e",
  null
  
)

export default component.exports